import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import { Event, NavigationStart, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';
import { ImpersonationService } from '../services/impersonation.service';
import { NavigationMenuService } from '../services/navigation-menu.service';
import { ToastService } from '../services/toast.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HeaderComponent implements OnInit {
  constructor(
    private NavigationMenuService: NavigationMenuService,
    private router: Router,
    private AuthService: AuthService,
    private ToastService: ToastService,
    private ImpersonationService: ImpersonationService
  ) {}

  bootstrap_md_breakPoint: number = 768; // This number is the default bootstrap v5 md breakpoint. If we ever change the default we should change this to keep breakpoints in sync.
  showToggleIcon: boolean = window.innerWidth <= this.bootstrap_md_breakPoint;
  isVendorRegistration: boolean = false;

  isVendorUser() {
    try {
      return this.AuthService.getUserVendorId();
    } catch (error) {
      return false;
    }
  }

  isUserLoggedIn() {
    return this.AuthService.isAuthenticated();
  }

  goToVendorDashboard() {
    const User = this.AuthService.getUser();

    if (!User) {
      throw this.ToastService.addErrorToast('Error', 'User is not logged in.', {
        returnError: true
      });
    }

    const { id: UserId, CompanyId, VendorId, UserAccountType } = User;

    if (!UserId) {
      throw this.ToastService.addErrorToast('Error', 'User is missing id.', {
        returnError: true
      });
    }

    if (!UserAccountType) {
      throw this.ToastService.addErrorToast(
        'Error',
        'User is missing permissions.',
        { returnError: true }
      );
    }

    this.router.navigate([`vendor/${VendorId}/dashboard`]);
  }

  goToUserPage() {
    const User = this.AuthService.getUser();

    if (!User) {
      throw this.ToastService.addErrorToast('Error', 'User is not logged in.', {
        returnError: true
      });
    }

    const { id: UserId, CompanyId, VendorId, UserAccountType } = User;

    if (!UserId) {
      throw this.ToastService.addErrorToast('Error', 'User is missing id.', {
        returnError: true
      });
    }

    if (!UserAccountType) {
      throw this.ToastService.addErrorToast(
        'Error',
        'User is missing permissions.',
        { returnError: true }
      );
    }

    const { name } = UserAccountType;

    const NameToRouteMap = {
      Admin: 'admin',
      Client: `client/${CompanyId}/admin`,
      Vendor: `vendor/${VendorId}`,
      'External Vive Level 1': 'admin',
      'External Vive Level 2': 'admin'
    };

    this.router.navigate([NameToRouteMap[name], 'user', UserId]);
  }

  logout() {
    this.router.navigate(['logout']);
  }

  public isImpersonating(): boolean {
    return this.ImpersonationService.isImpersonating();
  }

  public impersonationTargetName(): string | null {
    return this.ImpersonationService.getImpersonation()?.targetName ?? null;
  }

  public returnToMyAccount(): void {
    this.ImpersonationService.returnToMyAccount();
  }

  openHelpCenter() {
    window.open(
      'https://support.getvived.com/hc/en-us/categories/29859212679323-Vendor-Help-Center-2-0',
      '_blank'
    );
  }

  openLiveChat() {
    window.$zopim.livechat.window.show();
  }

  toggleMenu() {
    this.NavigationMenuService.sendEvent('toggleNavMenu');
  }

  ngOnInit(): void {
    this.router.events.subscribe({
      next: (event: Event) => {
        if (event instanceof NavigationStart) {
          if (event.url.includes('/login')) {
            this.showToggleIcon = false;
          }
          this.isVendorRegistration = event.url.includes('vendor-registration');
        }
      }
    });
  }
}
